"use server";
import "server-only";
import axios, { AxiosError, AxiosInstance } from "axios";

let _client: AxiosInstance | null = null;
let metaData = {}

type Config = {
  baseURL: string;
  apiKey: string;
  apiSecret: string;
};

export interface AxiosResponseDataType<T> {
  success: boolean,
  data?: T,
  message?: string
}

export async function initPremiumClient(
  config: Config
): Promise<AxiosInstance> {
  // if (_client) return _client;

  const { baseURL, apiKey, apiSecret } = config;

  if (!baseURL || !apiKey || !apiSecret) {
    throw new Error(
      "[NextAuthKit] Missing configuration. Ensure Provider is initialized."
    );
  }
  _client = axios.create({
    baseURL,
    headers: {
      "X-API-KEY": apiKey,
      "X-API-SECRET": apiSecret,
    },
  });

  try {
    await _client.get("/ping");
  } catch (error) {
    const err = error as AxiosError;
    console.log(err.code)
    _client = null;
    switch (err.code) {
      case "ECONNREFUSED":
        throw new Error(
          "Server is unreachable. Check baseURL or server status."
        );
        break;
      case "EPROTO":
        throw new Error(
          "Server is unreachable. Check baseURL or server status."
        );

      case "ERR_BAD_REQUEST":
        throw new Error(
          "Server is unreachable. or cannot get /ping on your server. Check baseURL or server status."
        );

      default:
        throw new Error(
          "Server is unreachable. or cannot get /ping on your server. Check baseURL or server status."
        );
        break;
    }
  }

  return _client;
}

export async function getPremiumClient(): Promise<AxiosInstance> {
  if (!_client) {
    throw new Error(
      "[NextAuthKit] Client not initialized. Wrap your app with <NextAuthKitProvider />"
    );
  }
  return _client;
}
